import React from "react";
import { Modal, Button, Row, Col, Pagination } from "antd";

export default function NotFoundSerialsModal({
  visible,
  onClose,
  notFoundSerialsList,
  notFoundSerialsPage,
  notFoundSerialsPageSize,
  onPageChange,
}) {
  return (
    <Modal
      title="Seriales no encontrados"
      open={visible}
      onOk={onClose}
      onCancel={onClose}
      footer={[
        <Button key="ok" type="primary" onClick={onClose}>
          OK
        </Button>,
      ]}
    >
      {notFoundSerialsList.length === 0 ? (
        <div>Ningún serial del archivo corresponde a préstamos activos</div>
      ) : (
        <>
          <Row gutter={[8, 8]}>
            {notFoundSerialsList
              .slice(
                (notFoundSerialsPage - 1) * notFoundSerialsPageSize,
                notFoundSerialsPage * notFoundSerialsPageSize
              )
              .map((serial, idx) => (
                <Col span={6} key={idx}>
                  <div
                    style={{
                      background: "#f5f5f5",
                      borderRadius: 4,
                      padding: "4px 8px",
                      textAlign: "center",
                      fontFamily: "monospace",
                      minHeight: 28,
                    }}
                  >
                    {serial}
                  </div>
                </Col>
              ))}
          </Row>
          <Pagination
            current={notFoundSerialsPage}
            pageSize={notFoundSerialsPageSize}
            total={notFoundSerialsList.length}
            onChange={onPageChange}
            style={{ marginTop: 16, textAlign: "center" }}
            showSizeChanger={false}
          />
        </>
      )}
    </Modal>
  );
} 